document.addEventListener("DOMContentLoaded", function () {
  /* BLOG */
  if (document.querySelectorAll("#select-order-blog").length > 0) {
    let filterBlog = document.getElementById("select-order-blog");
    filterBlog.addEventListener("change", refreshBlog, false);
    function refreshBlog() {
      var url = window.location.href.split("?");
      window.location.href = url[0] + "?date=" + document.getElementById("select-order-blog").value;
    }
  }
});
